import { useParams, Navigate, Outlet } from "react-router-dom";
import { I18nProvider, type SiteLocale } from "@/i18n";

const SUPPORTED_LOCALES: SiteLocale[] = ["it", "en"];

export default function LanguageLayout() {
  const { lang } = useParams<{ lang: string }>();

  if (!lang || !SUPPORTED_LOCALES.includes(lang as SiteLocale)) {
    // Detect browser language, default to Italian
    const browserLang = navigator.language?.split("-")[0];
    const target = SUPPORTED_LOCALES.includes(browserLang as SiteLocale) ? browserLang : "it";
    return <Navigate to={`/${target}/`} replace />;
  }

  return (
    <I18nProvider locale={lang as SiteLocale}>
      <Outlet />
    </I18nProvider>
  );
}
